// @NOTE: EVERYTHING related to adding tags/dishes is a placeholder, we need autocomplete, search, pills inside input, functionality, etc....
// @TODO: Tag remove, tags input autocomplete, tags add, tag pill inside input (we need a new component for this)
// @TODO: Detect dish
// @TODO: Dishes autocomplete, dish switch

import { useState } from "react";
import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";

import { useDrawer } from "@hmn/coolinarika-web-core/hooks";

import { Button, buttonSizes, buttonVariants } from "../../../Button";
import { DrawerBody, DrawerFooter, DrawerSeparator, DrawerTextBlock } from "../../../Drawer";
import { withErrorBoundary } from "../../../ErrorBoundary";
import { CheckMarkIcon, Icon } from "../../../Icon";
import { TextField } from "../../../Input/components";
import { TagPill, TagPillsList } from "../../../Tag/components";
import styles from "./Tags.style";

const DrawerTagsStyled = styled.div((props) => ({ ...styles(props) }));

const DrawerTags = () => {
    // @TODO: remove use state for inputs, this is for sprint demo only
    const [tagsValue, setTagsValue] = useState("");
    const [dishValue, setDishValue] = useState("");
    const uid = useUIDSeed();

    const { open: openUploaderSuccessDrawer } = useDrawer("drawer-recipe-uploader-success");

    // @TODO: remove fake data
    const tags = [
        { id: "1", title: "slanutak" },
        { id: "2", title: "vegeta" },
        { id: "3", title: "kotleti" },
        { id: "4", title: "meso" },
        { id: "5", title: "marinada" },
        { id: "6", title: "papar" },
        { id: "7", title: "rucak-za-sutra" },
        { id: "8", title: "rostiljanje" },
        { id: "9", title: "janjetina" },
        { id: "10", title: "pire" },
        { id: "11", title: "rucak" },
    ];

    return (
        <DrawerTagsStyled>
            <DrawerBody>
                <DrawerTextBlock
                    description="Ove tagove smo prepoznali automatski, no ako želiš, možeš ih urediti."
                    bottomSpacing={15}
                />
                <TagPillsList>
                    {tags?.map((tag, index) => (
                        <TagPill
                            key={uid(tag?.id || index)}
                            label={tag?.title}
                            value={tag?.id}
                            id={tag?.id}
                            // eslint-disable-next-line no-alert
                            onClick={() => alert("TODO: Remove tag")}
                            hasRemoveIcon
                        />
                    ))}
                </TagPillsList>

                <div className="drawerTags_inputContainer">
                    {/* @TODO: Replace with tag autocomplete, add tags add functionality */}
                    <TextField
                        placeholder="Dodaj tagove..."
                        value={tagsValue}
                        onChange={(e) => setTagsValue(e.target.value)}
                        actionComponentRenderCondition={tagsValue.trim()}
                        actionComponent={() => (
                            <Button
                                title="Dodaj"
                                variant={buttonVariants.QUATERNARY}
                                size={buttonSizes.SMALL}
                                // eslint-disable-next-line no-alert
                                onClick={() => alert("TODO: Add tag")}
                            >
                                Dodaj
                            </Button>
                        )}
                    />
                </div>

                <DrawerSeparator />
                <DrawerTextBlock
                    description="Tvoj recept prepoznali smo kao..."
                    bottomSpacing={15}
                />
                <TagPillsList>
                    {/* @TODO: get dish tag/label */}
                    <TagPill label="gulaši / gulaš od gljiva" />
                </TagPillsList>

                <div className="drawerTags_inputContainer">
                    {/* @TODO: Replace with dish search, dish switch functionality */}
                    <TextField
                        placeholder="Nismo dobro prepoznali jelo? Pomozi nam"
                        value={dishValue}
                        onChange={(e) => setDishValue(e.target.value)}
                        actionComponentRenderCondition={dishValue.trim()}
                        actionComponent={() => (
                            <Button
                                title="Zamijeni"
                                variant={buttonVariants.QUATERNARY}
                                size={buttonSizes.SMALL}
                                onClick={() =>
                                    // eslint-disable-next-line no-alert
                                    alert(
                                        "TODO: Input autocomplete, dish pill display, switch dish",
                                    )
                                }
                            >
                                Zamijeni
                            </Button>
                        )}
                    />
                </div>
            </DrawerBody>
            <DrawerFooter>
                <Button
                    onClick={openUploaderSuccessDrawer}
                    title="Snimi recept"
                    variant={buttonVariants.QUATERNARY}
                    size={buttonSizes.LARGE}
                    sizeMobile={buttonSizes.NORMAL}
                    width="100%"
                    iconLeftComponent={<Icon icon={CheckMarkIcon} />}
                >
                    Snimi recept
                </Button>
            </DrawerFooter>
        </DrawerTagsStyled>
    );
};

export default withErrorBoundary(DrawerTags);
